import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import { DF_OT0070Context } from "../context";
import NotificationModal from "../../../components/Common/NotificationModal";
import TableSimple from "../../../components/Dynamic/TableSimple";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import { isLoading } from "../../../store/layout/actions";
import ModalIframePage from "../../../components/Common/ModalIframePage";


function GridBody() {

  const dispatch = useDispatch(); 

  const { csrfToken, access_token, userProfile } = useContext(DF_OT0070Context);
  const [triggerType, setTriggerType] = useState([])
  const [showTable, setShowTable] = useState(false)
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)

  const [preFilter, setPreFilter] = useState([]);
  const [paramsOnItem, setParamsOnItem] = useState({})

  const [openModalHistoric, setOpenModalHistoric] = useState(false)
  const [dataModalHistoric, setDataModalHistoric] = useState([])

  const [OpenModalRemoveAgenda, setOpenModalRemoveAgenda] = useState(false)
  const [OpenModalRemoveAgendaSuccess, setOpenModalRemoveAgendaSuccess] = useState(false)

  const handleTriggers = async (trigger) => {
    const params = trigger?.params?.split('&').reduce((acc, curr) => {
      const [key, value] = curr.split('=');
      acc[key] = value;
      return acc;
    }, {});
    setParamsOnItem(params) 

    if(trigger?.config?.type === "EXEC_PROC" && trigger?.transaction_id === 'DF_OT0073') setOpenModalHistoric(true)
    else if(trigger?.config?.type === "EXEC_PROC" && trigger?.transaction_id === 'DF_OT0072' ) setOpenModalRemoveAgenda(true)
    setTriggerType(trigger)
  }

  const handleFilter = async () => {
    setTriggerOnFilter(true)
    setShowTable(true);
  }

  const handleHistoric = async () => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        paramsOnItem,
        triggerType?.config?.procName,
        csrfToken,
        access_token,
      );
      setDataModalHistoric(resp);
    } catch (error) {
      console.log("erro ao remover agenda fixa", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  const handleRemoveAgenda = async () => {
    dispatch(isLoading(true));
    try {
      const resp = await BizinBackend.executeProcedure(
        paramsOnItem,
        triggerType?.config?.procName,
        csrfToken,
        access_token,
      );
      setOpenModalRemoveAgenda(false)
      setOpenModalRemoveAgendaSuccess(true)
    } catch (error) {
      console.log("erro ao remover agenda fixa", error);
    } finally {
      dispatch(isLoading(false));
    }
  }

  useEffect(() => {
    if(openModalHistoric) handleHistoric()
  }, [openModalHistoric])

  return (
    <div className="vh-100 p-0">
      <div className="bg-white mb-3 card-content shadow-card p-4">
          <div className="row d-flex align-items-center px-4">
            <div className="col-12 col-md-3 p-md-0 pe-lg-3 form-custom01-filter">
              <TranspaleStringToComponente
                elementId={"Data_Inicio"}
                elementProps={{
                  value: new Date().toLocaleDateString(),
                  type: 'Date',
                  title: "De",
                  id: "Filtro_Data_Inicio",
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>            
            <div className="col-12 col-md-4 p-md-0 pe-lg-3">
             <TranspaleStringToComponente
                elementId={"ID_Empresa_Origem"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Empresa Origem",
                  id: "Filtro_ID_Empresa_Origem",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Empresas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'ORIGEM', 'NF']
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-4 p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Local_Entrega"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Local Entrega",
                  id: "Filtro_ID_Local_Entrega",
                  isDisabled: false,
                  procedure: "SRM_Agendamento_Local_Entrega",
                  procedureParams: [userProfile?.ID_Usuario, '<#Filtro_ID_Empresa_Origem#>'],
                  alienated: ["Filtro_ID_Empresa_Origem"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-3 p-md-0 pe-lg-3 form-custom01-filter">
              <TranspaleStringToComponente
                elementId={"Data_Fim"}
                elementProps={{
                  value: new Date().toLocaleDateString(),
                  type: 'Date',
                  title: "Até",
                  id: "Filtro_Data_Fim",
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-4 p-md-0 pe-lg-3">
             <TranspaleStringToComponente
                elementId={"ID_Empresa_Destino"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Empresa Destino",
                  id: "Filtro_ID_Empresa_Destino",
                  isDisabled: false,
                  procedure: "FRONT_Componente_Combo_Empresas",
                  procedureParams: [userProfile?.ID_Usuario, 'pt-BR', 'DESTINO', 'NF']
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
            <div className="col-12 col-md-4 p-md-0 pe-lg-3">
              <TranspaleStringToComponente
                elementId={"ID_Local_Desembarque"}
                elementProps={{
                  value: '',
                  type: 'Combobox',
                  title: "Local Desembarque",
                  id: "Filtro_ID_Local_Desembarque",
                  isDisabled: false,
                  procedure: "FRONT_Agendamento_Obter_Lista_Locais_Desembarque",
                  procedureParams: [preFilter[0]?.["Filtro_ID_Empresa_Origem"]?.value || null, '<#Filtro_ID_Local_Entrega#>'],
                  alienated: ["Filtro_ID_Local_Entrega"]
                }}
                preFilter={preFilter}
                onPreFilter={(filters) => setPreFilter(state => [{ ...state[0], ...filters }])}
              />
            </div>
              <div className="col-md-1 col d-flex align-self-end p-0 mb-md-3 mb-0">
                <button className="btn btn-primary-dark text-white font-size-16 fw-semibold w-100" onClick={handleFilter} >Pesquisar</button>
              </div>
          </div>
      </div>
      
      {showTable && (
        <div className="col-12">
          <TableSimple
            dataKey={"ID_Agenda_Fixa"}
            procName={"FRONT_Workspace_DF_OT0070_Tabela_Grid_V16"}
            procParams={`[
              ${userProfile.ID_Usuario},
              "pt-BR",
              1,
              10,
              "<#Filtro_ID_Empresa_Origem#>",
              "<#Filtro_ID_Empresa_Destino#>",
              "<#Filtro_Data_Inicio#>",
              "<#Filtro_Data_Fim#>",
              "<#Filtro_ID_Local_Entrega#>",
              "<#Filtro_ID_Local_Desembarque#>",
              "<#Filtro_ID_Tipo_Agenda_Fixa#>",
              "<#Filtro_ID_Tipo_Veiculo#>",
              "<#Filtro_ID_Status#>"
              ]`}
            columnsList={[
              { field: "Status", hasImage: true, width: '3%', header: "Status" },
              { field: "Origem", header: "Origem", hasImage: true, sort: true },
              { field: "Destino", header: "Destino", hasImage: true, sort: true },
              { field: "Local_Entrega", header: "Local Entrega", sort: true },
              { field: "Local_Desembarque", header: "Local Desembarque", sort: true },
              { field: "Data_Agenda", header: "Data Agendada", sort: true },
              { field: "Coluna_Funcoes", hasImage: true, width: '2%', header: "", },
            ]}
            enableMinHeight
            triggerOnFilter={triggerOnFilter}
            setTriggerOnFilter={setTriggerOnFilter}
            callbackTriggers={handleTriggers}
            paramsOnFilter={preFilter}
          />
        </div>
      )}

      {/* Remover Agenda Fixa  */}
      <NotificationModal
        isOpen={OpenModalRemoveAgenda}
        type="warning"
        titleCustom="Deseja desativar a Agenda Fixa?"
        message={`Ao clicar em "Confirmar", a Agenda Fixa será desativada e não poderá ser reativada. Será necessário cadastrar uma nova.`}
        confirmButton
        onClose={() => setOpenModalRemoveAgenda(false)}
        onConfirm={handleRemoveAgenda}
      />

      <NotificationModal
        isOpen={OpenModalRemoveAgendaSuccess}
        type="success"
        titleCustom="Sucesso!"
        message="Agenda Fixa desativada com sucesso!"
        onClose={() => {
          setOpenModalRemoveAgendaSuccess(false)
          handleFilter();
        }}
      />
      {/* end */}

      {/* MODAL HISTORICO */}
      <ModalIframePage 
        openModal={openModalHistoric} 
        onClosed={() => setOpenModalHistoric(false)}
        triggerType={triggerType}
      >
        <div>
          <TableSimple
            dataKey={"ID_Log"}
            data={dataModalHistoric?.length > 0 ? dataModalHistoric : []}
            enableTotalRows
            hiddenPaginator
            columnsList={[
              { field: "DataHora", header: "Dt. Registro"},
              { field: "Nome_Usuario", header: "Nome Usuário"},
              { field: "Mensagem", header: "Descricao" },
            ]}
          />
        </div>
      </ModalIframePage>
      
    </div>
  )
}

export default GridBody;
